import React from "react";
import './styles.scss'
import Descriptions from "../../common/Descriptions/Descriptions";
import {IDescriptionsData} from "../../common/Descriptions/Descriptions.types";
import {IShipmentDetailsData} from "../../../api/Shipment.ShipmentDetails/Shipment.ShipmentDetails.types";

interface Props {
    shipmentDetails?: IShipmentDetailsData
}

function ShipmentDetails ({shipmentDetails}: Props) {
    function serializeData(){
        if(!shipmentDetails) return null;

        let ret:IDescriptionsData[] = [];
        Object.keys(shipmentDetails).forEach((key) => {
            ret.push({ title: getDisplayName(key), value: (shipmentDetails as any)[key] })
        })
        return ret;
    }

    function getDisplayName(key: string) {
        switch (key) {
            case 'referenceNumber':
                return ("Reference Number");
            case 'csr':
                return ("CSR");
            case 'dashboardMilestone':
                return ("Dashboard Milestone");
            case 'status':
                return ("Status");
            case 'po':
                return ("PO");
            case 'salesOrder':
                return ("Sales Order");
            case 'bookingNumber':
                return ("Booking Number");
            case 'deliveryNumber':
                return ("Delivery Number");
            case 'division':
                return ("Division");
            case 'customer':
                return ("Customer");
            case 'shipper':
                return ("Shipper");
            case 'incoTerms':
                return ("INCO Terms");
            case 'placeOfReceipt':
                return ("Place Of Receipt");
            case 'portOfLoading':
                return ("Port Of Loading");
            case 'portOfDischarge':
                return ("Port Of Discharge");
            case 'placeOfDelivery':
                return ("Place Of Delivery");
            case 'carrierName':
                return ("Carrier Name");
            case 'vesselVoyage':
                return ("Vessel/Voyage");
        }
        
        return ("");
    }

    return (
        <div className="shipment-details">
            <Descriptions data={serializeData() || []}/>
        </div>
    )
}

export default ShipmentDetails;